import { c as _c } from "react/compiler-runtime";
interface BottomNavTreatmentCaseIconProps {
  className?: string;
}
const BottomNavTreatmentCaseIcon = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  const t1 = `${className}`;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect x="6.25" y="5" width="18.0625" height="21.25" rx="2.55" fill="currentColor" />;
    t3 = <rect x="8.75" y="17.5" width="12.5" height="1.625" rx="0.8125" fill="white" />;
    t4 = <rect x="8.75" y="21.25" width="7.5" height="1.625" rx="0.8125" fill="white" />;
    t5 = <path d="M16.667 9.48301C16.667 9.53824 16.7118 9.58301 16.767 9.58301H18.65C18.7052 9.58301 18.75 9.62778 18.75 9.68301V11.566C18.75 11.6212 18.7052 11.666 18.65 11.666H16.767C16.7118 11.666 16.667 11.7108 16.667 11.766V13.65C16.667 13.7052 16.6222 13.75 16.567 13.75H14.683C14.6278 13.75 14.583 13.7052 14.583 13.65V11.766C14.583 11.7108 14.5382 11.666 14.483 11.666H12.6C12.5448 11.666 12.5 11.6212 12.5 11.566V9.68301C12.5 9.62778 12.5448 9.58301 12.6 9.58301H14.483C14.5382 9.58301 14.583 9.53824 14.583 9.48301V7.6C14.583 7.54477 14.6278 7.5 14.683 7.5H16.567C16.6222 7.5 16.667 7.54477 16.667 7.6V9.48301Z" fill="white" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t1) {
    t6 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" width="30" height="30">{t2}{t3}{t4}{t5}</svg>;
    $[4] = t1;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default BottomNavTreatmentCaseIcon;